import { AccordionContent as RadixAccordionContent, AccordionContentProps } from '@radix-ui/react-accordion';
import { cn } from '@woonstad/helpers-utils';

export function AccordionContent(props: { children?: React.ReactNode } & AccordionContentProps) {
  const {
    className,
    children,
    ...accordionContentProps
  } = props;

  return (
    <RadixAccordionContent
      className={cn('group/accordion-content accordion-wrapper', className)}
      forceMount
      {...accordionContentProps}
    >
      <div className="accordion">
        <div
          className={cn('overflow-hidden',
            'group-data-[state=open]/accordion-content:duration-1000 group-data-[state=open]/accordion-content:animate-in group-data-[state=open]/accordion-content:fade-in',
            'group-data-[state=closed]/accordion-content:duration-100 group-data-[state=closed]/accordion-content:animate-out group-data-[state=closed]/accordion-content:fade-out group-data-[state=closed]/accordion-content:fill-mode-forwards')}
        >
          {children}
        </div>
      </div>
    </RadixAccordionContent>
  );
}
